import React, { useState, useEffect } from "react";

import {
  Grid,
  Box,
  Alert,
  CircularProgress,
  Container,
  Typography,
  FormControlLabel,
  Divider,
  Switch,
  Button,
} from "@mui/material";

import UsernamePasswordPair from "../components/user.pair.component";

import { useStateContext } from "../context/ContextProvider";

import axiosClient from "../axiosClient";

export default function UsersScreen() {
  const [message, setMessage] = useState();
  const [errorMessage,setErrorMessage] = useState();
  const [userChanged, setUserChanged] = useState();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [privMessage,setPrivMessage] = useState();

  const [cashierPermissions, setCashierPermissions] = useState([]);
  const [managerPermissions, setManagerPermissions] = useState([]);

  const { store } = useStateContext();

  const permissions = [
    "Discount",
    "Void",
    "Return",
    "Price change",
    "Z report",
    "X report",
    "Re-print invoice",
    "Re-print Z",
    "Open drawer",
    "Change payment type",
  ];

  useEffect(() => {
    setLoading(true);
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g,"");
    const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

    axiosClient
      .get(`user/${databaseStoreName}`)
      .then((response) => {
        setUsers(response.data.data);
        setLoading(false);

        const managerPrivileges = response.data.data[1].Privileges.map(
          (privilegeObj) => privilegeObj.privilege
        );
        const cashierPrivileges = response.data.data[2].Privileges.map(
          (privilegeObj) => privilegeObj.privilege
        );
        setManagerPermissions(managerPrivileges);
        setCashierPermissions(cashierPrivileges);
      })
      .catch((err) => console.log(err));
  }, [store]);

  if (loading) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  return (
    <Container container style={{ margin: 2 }} xs={12}>
      <Typography variant="h5" gutterBottom>
        User Management
      </Typography>
      <Divider />
      <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        Passwords
      </Typography>
      {message && (
        <Alert
          severity="success"
          sx={{ marginBottom: 2 }}
        >{`For user ${userChanged}: ${message}`}</Alert>
      )}
      {errorMessage && (
        <Alert
          severity="error"
          sx={{ marginBottom: 2 }}
        >{`For user ${userChanged}: ${errorMessage}`}</Alert>
      )}
      <Box sx={{ margin: 3 }} />
      <Grid container spacing={2} justify="flex-start">
        {users.map((user) => (
          <Grid item xs={12}>
            <UsernamePasswordPair
              role={user.role}
              label={user.role}
              setUserChanged={setUserChanged}
              setMessage={setMessage}
              setErrorMessage={setErrorMessage}
            />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ margin: 3 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
      <Grid item>
        <Typography variant="h6" gutterBottom>
          Permissions
        </Typography>
        {privMessage && (
        <Alert
          severity="success"
          sx={{ marginBottom: 2 }}
        >{privMessage}</Alert>
      )}
        <Box sx={{ margin: 3 }} />
      </Grid>
      <Grid container>
        <Grid item xs={12} md={4} lg={4} sm={4}>
          <Typography variant="body1">Admin</Typography>
          {permissions.map((permission, index) => (
            <Grid item xs={12} md={4} lg={4} sm={4}>
              <FormControlLabel
                key={index}
                control={
                  <Switch disabled defaultChecked color="primary" />
                }
                label={permission}
              />
            </Grid>
          ))}
        </Grid>
        <Grid item xs={12} md={4} lg={4} sm={4}>
          <Typography variant="body1">Manager</Typography>
          {permissions.map((permission, index) => (
            <Grid item xs={12} md={4} lg={4} sm={4}>
              <FormControlLabel
                key={index}
                control={
                  <Switch
                    checked={managerPermissions.includes(permission)}
                    value={permission}
                    color="primary"
                    onChange={() => {
                      if (managerPermissions.includes(permission)) {
                        setManagerPermissions(
                          managerPermissions.filter((p) => p !== permission)
                        );
                      } else {
                        setManagerPermissions([
                          ...managerPermissions,
                          permission,
                        ]);
                      }
                    }}
                  />
                }
                label={permission}
              />
            </Grid>
          ))}
          <Box sx={{ margin: 2 }} />
          <Grid item xs={12} md={4} lg={4} sm={4}>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g,"");
                const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

                const payload = {
                  userId: 2,
                  userPrivileges: managerPermissions,
                  shopName: databaseStoreName,
                };
                axiosClient
                  .patch("/user/privileges", payload)
                  .then((response) => setPrivMessage(`Manager: ${response.data.message}`))
                  .catch((err) => console.log(err));
              }}
            >
              Change manager permissions
            </Button>
          </Grid>
          <Box sx={{ margin: 2 }} />
        </Grid>
        <Grid item xs={12} md={4} lg={4} sm={4}>
          <Typography variant="body1">Cashier</Typography>
          {permissions.map((permission, index) => (
            <Grid item xs={12} md={4} lg={4} sm={4}>
              <FormControlLabel
                key={index}
                control={
                  <Switch
                    checked={cashierPermissions.includes(permission)}
                    value={permission}
                    color="primary"
                    onChange={() => {
                      if (cashierPermissions.includes(permission)) {
                        setCashierPermissions(
                          cashierPermissions.filter((p) => p !== permission)
                        );
                      } else {
                        setCashierPermissions([
                          ...cashierPermissions,
                          permission,
                        ]);
                      }
                    }}
                  />
                }
                label={permission}
              />
            </Grid>
          ))}
          <Box sx={{ margin: 2 }} />
          <Grid item xs={12} md={4} lg={4} sm={4}>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g,"");
                const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

                const payload = {
                  userId: 3,
                  userPrivileges: cashierPermissions,
                  shopName: databaseStoreName,
                };
                axiosClient
                  .patch("/user/privileges", payload)
                  .then((response) => setPrivMessage(`Cashier: ${response.data.message}`))
                  .catch((err) => console.log(err));
              }}
            >
              Change cashier permissions
            </Button>
          </Grid>
          <Box sx={{ margin: 2 }} />
        </Grid>
      </Grid>
    </Container>
  );
}
